module.exports = __webpack_public_path__ + "img/activetdashboard.a8bbaf11.svg";